import { ReactNode, Children, isValidElement } from 'react';

export function ensureButtons(children: ReactNode) {
    return Children.toArray(children).every(
        (c: { type: { displayName: string } }) =>
            isValidElement(c) &&
            typeof c.type === 'function' &&
            c?.type?.displayName === 'Button',
    );
}
